// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LazyMedia_spinner__WtNjI","spin":"LazyMedia_spin__Qdqzq"};